import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteIncidentIssueInput, DeleteIncidentIssueBulkResponse, MutationDeleteIncidentIssueBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteIncidentIssue } from '@/features/IncidentHistory/api/queries/DeleteIncidentIssue';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteIncidentIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteIncidentIssueBulkResponse>;
}

// DeleteIncidentIssue Service
export const { deleteIncidentIssue, useDeleteIncidentIssue } = ((): {
  deleteIncidentIssue: ServiceMethod;
  useDeleteIncidentIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteIncidentIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteIncidentIssueInput[], options?: ConnectionOptions): Promise<DeleteIncidentIssueBulkResponse> => {
        const args: MutationDeleteIncidentIssueBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteIncidentIssueBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteIncidentIssueBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteIncidentIssue: fetch,
    useDeleteIncidentIssue: useService,
  };
})();
